// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import { ConstructBasicElement, GetCopyFromJson } from '~/contentstack/rendering';

import './TableSection.scss';

export const query = graphql`
	fragment TableFragment on Ozk_content_blockModular_blocksCopyContent {
		table {
			table_editor {
				json
			}
		}
	}
`;

/**
 * @typedef TableOptions
 * @property {import('~/templates/CSTypes').CSJRTE} table_editor The JRTE containing the table.
 */
/** @type {import('~/types/React').ReactFC<{ options: TableOptions }>} */
const TableSection = ({ options }) => {
	const output = GetCopyFromJson(options.table_editor, ConstructBasicElement('p', 'fragment'));

	// TODO: Make this look good on mobile - it does not.

	return <div className="table-section">{output}</div>;
};

export default TableSection;
